import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getMyProfiles, deleteProfile } from "../api/resume.api";

export const useMyProfiles = (enabled: boolean = true) =>
  useQuery({
    queryKey: ["myProfiles"],
    queryFn: getMyProfiles,
    enabled,
  });

export const useDeleteMyProfile = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number | string) => deleteProfile(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["myProfiles"] });
    },
  });
};

